export enum WhiteLabelType {
  DEBOUWAPP = 'de BouwApp',
  SITEPODIUM = 'SitePodium',
  DEBOUWAPPTEST = 'de BouwApp TEST',
  WHITELABELTEST = 'De Whitelabel TEST',
}
